import AcceptanceRuleShow from "@/view/acceptance_rule/acceptance_rule_show.vue";
import AcceptanceRuleList from "@/view/acceptance_rule/acceptance_rule_list.vue";
import AcceptanceRuleEdit from "@/view/acceptance_rule/acceptance_rule_edit.vue";
import AcceptanceRuleNew from "@/view/acceptance_rule/acceptance_rule_new.vue";

const acceptanceRule = [
  {
    path: "/acceptance_rule", 
    component: AcceptanceRuleList, 
    name: "acceptance_rule_list", 
    meta: {
      title: 'Regra de Aceitação',
      auth: false,
    }
  },
  {path: "/acceptance_rule/:id/show", component: AcceptanceRuleShow, name: "acceptance_rule_show"},
  {path: "/acceptance_rule/:id/edit", component: AcceptanceRuleEdit, name: "acceptance_rule_edit"},
  {path: "/acceptance_rule/new", component: AcceptanceRuleNew, name: "acceptance_rule_new"}
];

export default acceptanceRule;
